<template>
    <div class="font-fira font-light">
        <visualz name="protection">
            <div class="w-full p-8 leading-normal h-full " @click="$modal.hide('protection')">
                Feltöltés alatt!
            </div>
        </visualz>
        <visualz name="impressum" height="auto" width="800px" :scrollable="true" :adaptive="true">
            <div class="w-full p-8 leading-normal h-full " @click="$modal.hide('impressum')">
                <div class="flex flex-row w-full items-center">
                    <img class="w-32 w-24" src="../assets/visualz_landing_hero.png">
                    <span class="block font-hairline text-5xl text-v-green ml-2">|</span>
                    <h1 class="lg:text-3xl text-xl font-hairline ml-2">Imresszum</h1>
                </div>
                <div class="w-full leading-loose">
                    Tárhelyszolgáltatónk a Tárhely.Eu Kft.
                    <hr>
                    Székhelye és telephelye: 1144 Budapest, Ormánság utca 4. X. em. 241.
                    <hr>
                    Email címe: iroda@tarhely.eu
                    <hr>
                    <span class="leading-tight">A weboldalt cégünk üzemelteti, melynek hivatalos cégneve: VISUALZ Webdesign & Branding Stúdió Kft.</span>
                    <hr>
                    Cégjegyzékben szereplő székhelyünk és telephelyünk: 1096 Budapest, Lenhossék utca 3. A. lház. 1. em.
                    1.
                    <hr>
                    Email címünk: hello@visualz.hu
                    <hr>
                    Adószámunk: 25972373-2-43
                    <hr>
                    Budapesti Kereskedelmi és Iparkamarához tartozunk.
                    <hr>
                    Fővárosi Törvényszék Cégbírósága által kerültünk nyilvántartásba.
                    <hr>
                </div>
            </div>
        </visualz>
        <visualz name="success">
            <div class="p-8" @click="$modal.hide('success')">
                Az üzenetedet sikeresen elküldtük!
            </div>
        </visualz>
        <visualz name="error">
            <div class="p-8" @click="$modal.hide('error')">
                Hiba történt, próbáld meg később!
            </div>
        </visualz>

    </div>
</template>

<script>
export default {
  name: 'Modalz',
  methods: {
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Modalz.vue